import { Component, OnInit, ViewChild, ElementRef, TemplateRef, inject } from '@angular/core';
import { UtilityService } from '../index';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalNotificationMessage } from '../types/modal_notification_message';

export interface ErrorMap {
  [key: string]: boolean;
}

@Component({
    selector: 'app-xsact-body',
    templateUrl: 'xsact-body.component.html',
    styleUrls: ['xsact-body.component.scss'],
    standalone: false
})
export class XsactBodyComponent implements OnInit {
  private utilitySvc = inject(UtilityService);
  private modalService = inject(BsModalService);

  @ViewChild('appNotificationModalWrapper', { read: TemplateRef }) appModal: TemplateRef<void>;
  appNotificationModal: BsModalRef;

  appModalData: ModalNotificationMessage;

  ngOnInit() {
    if (!navigator.cookieEnabled) {
      this.utilitySvc.showNotificationBar(
        'Transact and sites you purchase content from may not work properly with cookies disabled.',
        'cookieDisabledMessage'
      );
    }

    this.utilitySvc.appNotificationModal.subscribe((result: ModalNotificationMessage) => {
      if (result) {
        this.appModalData = result;
        this.appNotificationModal = this.modalService.show(this.appModal, { class: 'modal-lg' });
      }
    });
  }
}
